import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img
          src="/uploads/hero.jpg"
          alt="Fairfax Gazette - Your source for local news and community updates"
          className="hero-image"
        />
        <p className="eyebrow">Fairfax Gazette</p>
        <h1>Your Source for Local News and Community Updates</h1>
        <p className="lede">
          Stay connected to Fairfax with reliable news, event updates, and community insights.
        </p>
        <div className="cta-row">
          <a href="#latest-news" className="primary">
            Read the Latest
          </a>
        </div>
      </header>

      <section className="cards" id="latest-news">
        <article>
          <h2>Board saluted outgoing CSB director Daryl Washington</h2>
          <p>The Fairfax County Board of Supervisors recognized Daryl Washington, who stepped down as executive director of the Fairfax-Falls Church Community Services Board to take a state government position.</p>
        </article>
        <article>
          <h2>Crossing-guard elimination debate continues</h2>
          <p>A board member argues that removing crossing guards at high schools raises safety concerns without producing meaningful county savings.</p>
        </article>
      </section>

      <section className="cards">
        <article>
          <h2>Local News Coverage</h2>
          <p>
            Get the latest updates on local events, issues, and developments that matter to you.
          </p>
        </article>
        <article>
          <h2>Event Calendars</h2>
          <p>
            Discover upcoming events in Fairfax and never miss out on community happenings.
          </p>
        </article>
        <article>
          <h2>Business Spotlights</h2>
          <p>
            Learn about local businesses and support your community by shopping local.
          </p>
        </article>
        <article>
          <h2>Opinion Pieces</h2>
          <p>
            Engage with thought-provoking articles and share your perspective on local issues.
          </p>
        </article>
        <article>
          <h2>Public Service Announcements</h2>
          <p>
            Stay informed about important announcements and services available to Fairfax residents.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;